module.exports = __webpack_public_path__ + "img/63a1f72.jpg";